export const TYPEFORM_REPORT_TOKEN_KEY = "pendingTypeformReport";
export const LEGACY_TYPEFORM_REPORT_TOKEN_KEY = "testToken";

export const normalizeReportEmail = (email) =>
  typeof email === "string" ? email.trim().toLowerCase() : "";

export const clearLegacyTypeformReportToken = () => {
  localStorage.removeItem(LEGACY_TYPEFORM_REPORT_TOKEN_KEY);
};

export const clearPendingTypeformReport = () => {
  localStorage.removeItem(TYPEFORM_REPORT_TOKEN_KEY);
  clearLegacyTypeformReportToken();
};

export const getPendingTypeformReport = () => {
  clearLegacyTypeformReportToken();

  const rawValue = localStorage.getItem(TYPEFORM_REPORT_TOKEN_KEY);
  if (!rawValue) {
    return null;
  }

  try {
    const parsed = JSON.parse(rawValue);
    if (
      !parsed ||
      typeof parsed.token !== "string" ||
      !parsed.token ||
      typeof parsed.email !== "string" ||
      !parsed.email
    ) {
      clearPendingTypeformReport();
      return null;
    }

    return {
      ...parsed,
      email: normalizeReportEmail(parsed.email),
    };
  } catch {
    clearPendingTypeformReport();
    return null;
  }
};

export const getPendingTypeformReportForEmail = (email) => {
  const pendingReport = getPendingTypeformReport();
  if (!pendingReport) {
    return null;
  }

  if (pendingReport.email !== normalizeReportEmail(email)) {
    clearPendingTypeformReport();
    return null;
  }

  return pendingReport;
};

export const savePendingTypeformReport = ({ email, token }) => {
  clearLegacyTypeformReportToken();

  const normalizedEmail = normalizeReportEmail(email);
  if (!normalizedEmail || typeof token !== "string" || !token) {
    clearPendingTypeformReport();
    return null;
  }

  const pendingReport = {
    email: normalizedEmail,
    token,
    createdAt: new Date().toISOString(),
  };

  localStorage.setItem(TYPEFORM_REPORT_TOKEN_KEY, JSON.stringify(pendingReport));
  return pendingReport;
};
